module.exports = __webpack_public_path__ + "static/media/fylkirunknown.53b56b05.svg";